<template>
  <form class="thanks-page">
    <snow-select
      id="select-option"
      :options="[
        { id: 'default', name: 'Gerar pela ' + $config.get('title') },
        { id: 'external', name: 'Adicionar página externa' }
      ]"
      label="Opções de página"
      v-model="type"
    />

    <div v-if="type === 'external'" class="d-flex flex-column gap-4">
      <snow-input
        v-model="form.url_redirect"
        id="url_redirect"
        label="Compras aprovadas"
        info="Esta página é exibida se a compra for feita com cartão de crédito e já
        estiver aprovada."
        :errors="errors.url_redirect"
      />
      <snow-input
        v-model="form.url_redirect_credit_analysis"
        id="url_redirect_credit_analysis"
        label="Compras por pix"
        info="Esta página é exibida se a compra for feita por Pix"
        :errors="errors.url_redirect_credit_analysis"
      />
      <div v-if="form.url_redirect_credit_analysis">
        <snow-switch
          v-model="form.has_redirect_pix"
          label="Página customizada de pagamento Pix"
        />
        <span class="text-dark-40 fs-12">
          Marcar se deseja utilizar o widget de pagamento Pix. Caso contrário, o
          usuário será redirecionado para a página de obrigado após a aprovação
          do pagamento.
        </span>
      </div>

      <snow-input
        v-model="form.url_redirect_waiting"
        id="url_redirect_waiting"
        label="Compras por boleto"
        info="Esta página é exibida se a compra for feita por boleto bancário e estiver aguardando aprovação. Deve ser usada com o widget de boleto."
        :errors="errors.url_redirect_waiting"
      />

      <div class="d-flex align-items-start bg-5 p-4 rounded-16 gap-2">
        <i class="ph ph-warning-circle fs-18 pb-1" />
        <div class="d-flex flex-column">
          <h5 class="text-semibold">Atenção</h5>
          <span class="small-text text-secondary">
            Os códigos acima devem ser colocados dentro da tag body no código da
            sua página.
          </span>
        </div>
        <!-- <a
            target="_blank"
            href="https://ajuda.zeuspay.com.br/article/como-adicionar-um-widget-de-boleto-ou-upsell"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Veja como adicionar um widget à sua página de checkout.
            <i class="fa-solid fa-arrow-up-right-from-square ml-2"></i>
          </a> -->
      </div>

      <h5 class="text-semibold">Script para widget de boleto</h5>
      <snow-input readonly v-model="billetScript">
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-copy"
          @click="copyBilletScript"
        />
      </snow-input>
      <h5 class="text-semibold">Script para widget de upsell</h5>
      <snow-input readonly v-model="upsellScript">
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-copy"
          @click="copyUpsellScript"
        />
      </snow-input>
      <h5 class="text-semibold">Script para widget de pix</h5>
      <snow-input readonly v-model="pixScript">
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-copy"
          @click="copyPixScript"
        />
      </snow-input>
    </div>

    <!-- <hr class="mt-9 mb-9" />

    <div class="d-flex flex-column">
      <span class="font-weight-bold">Idioma</span>
      <span class="text-secondary "
        >Escolha em qual idioma devemos exibir a página de pagamento e enviar
        e-mails aos seus compradores.</span
      >

      <form-group
        type="radio"
        v-model="form.language"
        id="language"
        label=""
        :options="languageOptions"
        :errors="errors.language"
        :customClass="'col-12'"
      />
    </div> -->
  </form>
</template>

<script>
import copy from "copy-text-to-clipboard";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: ""
    };
  },
  watch: {
    type(val) {
      if (val === "default") {
        this.form.url_redirect = "";
        this.form.url_redirect_waiting = "";
        this.form.url_redirect_credit_analysis = "";
      }
    }
  },
  computed: {
    externalPages() {
      return (
        this.form.url_redirect !== "" ||
        this.form.url_redirect_waiting !== "" ||
        this.form.url_redirect_credit_analysis !== ""
      );
    },
    paymentBaseUrl() {
      return (
        process.env.VUE_APP_API_BASE_URL_PAY || "https://pay.zeuspay.com.br"
      );
    },
    billetScript() {
      return `<iframe id="zeuspay-billet-iframe"></iframe><script src="${this.paymentBaseUrl}/static/js/billet-client-min.js"><\/script>`;
    },
    upsellScript() {
      return `<iframe id="zeuspay-upsell-iframe"></iframe><script src="${this.paymentBaseUrl}/static/js/upsell-client-min.js"><\/script>`;
    },
    pixScript() {
      return `<iframe id="zeuspay-pix-iframe"></iframe><script src="${this.paymentBaseUrl}/static/js/pix-client-min.js"><\/script>`;
    }
  },
  methods: {
    copyBilletScript() {
      copy(this.billetScript);
      this.$message.success("Script copiado!");
    },
    copyUpsellScript() {
      copy(this.upsellScript);
      this.$message.success("Script copiado!");
    },
    copyPixScript() {
      copy(this.pixScript);
      this.$message.success("Script copiado!");
    }
  },
  mounted() {
    this.type = this.externalPages ? "external" : "default";
  }
};
</script>

<style lang="scss" scoped>
.thanks-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
